import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RSRlist.html?raw';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import "../BookingView";
import FinderBaseV2 from '../../FinderBase/FinderBaseV2';

import { TiEntities } from "../TiTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import TiBookingView from '../BookingView';
const enum TiBookingType {
    "reserved" = 1,
    "booked" = 2
}
class TiRouteSlotReviewList extends compose(FinderBaseV2) {

    templateString: any = template;

    // must-have attach-points in der template !!!  KlassenProperties sind bereits in der FinderBase deklariert  ------------------------------ start
    //filterPanelContainer: HTMLDivElement;
    //sectionResult: HTMLDivElement;
    //btnSubmitLabel: HTMLElement;
    //btnSubmit: HTMLElement;
    //btnContinue: HTMLElement;
    //btnContinueLabel: HTMLElement;
    //resultMessageErrorContainer: HTMLElement;
    //resultMessageError: HTMLElement;
    //resultContainer: HTMLElement;
    // must-have attach-points in der template !!!  KlassenProperties sind bereits in der FinderBase deklariert   ------------------------------ end

    tableContainer: HTMLElement; // will be passed as a function parameter

    //_isTableActive: boolean;
    buttonClickTimeout: number = null;
    _occurrenceEntityRequest: any = null;

    btnNewBooking: HTMLButtonElement;

    private _createSectionCellContent(entity: TiEntities.SectionTimeSlotEntity): string {
        let value = "";

        if (entity) {
            if (entity.ref_section_main_route.ref_section.ref_transport_type?.web_icon_class) {
                value += this.createFontawesomeIcon(entity.ref_section_main_route.ref_section.ref_transport_type.web_icon_class, "&nbsp;").outerHTML;
            }

            value += entity.ref_section_main_route.ref_section.code;

            value = this.UiModder.domConstruct.create("p", {
                className: "paddingSmall noMargin w3-center w3-block round",
                innerHTML: value
            }).outerHTML;

            let valueDate = "";
            valueDate += this.dateToString(
                entity.date_start,
                "dd.MM.yy HH:mm");

            if (entity.date_end) {
                valueDate += this.dateToString(
                    entity.date_end,
                    " - dd.MM.yy HH:mm");
            }

            value += this.UiModder.domConstruct.create("p", {
                className: "paddingSmall noMargin w3-center w3-block round",
                innerHTML: valueDate
            }).outerHTML;
        }

        if (entity?.BookingNumber) {
            let bookingNumberParagraph = this.UiModder.domConstruct.create("p", {
                className: "paddingSmall noMargin w3-center w3-block round",
                innerHTML: entity?.BookingNumber,
                "onclick": "event.stopPropagation();" // click bubbling verhindert wenn man die Buchungsnumber markiert
            });
            value += bookingNumberParagraph.outerHTML;
        }

        if (entity?.BookingStatus) {
            let bookingStatusParagraph = this.UiModder.domConstruct.create("p", {
                className: "paddingSmall noMargin w3-center w3-block round",
                innerHTML: entity?.BookingStatus,
                "onclick": "event.stopPropagation();" // click bubbling verhindert wenn man die BookingStatus markiert
            });
            value += bookingStatusParagraph.outerHTML;
        }

        if (entity?.ref_booking_status_timeslot) {
            let statusbubble = this.UiModder.domConstruct.create("p", {
                innerHTML: entity.ref_booking_status_timeslot.name,
                className: "paddingSmall noMargin w3-center w3-block bold round",
                style: {
                    "backgroundColor": entity.ref_booking_status_timeslot.coloration.BackColor.Hex,
                    "color": entity.ref_booking_status_timeslot.coloration.TextColor.Hex
                }
            });

            value += statusbubble.outerHTML;
        }

        return value;
    }

    private _formatTableCell(cell: StaticTable.StaticTableCell<TiEntities.BookingListEntity>) {

        let node = cell.contentnode;
        let entity: TiEntities.BookingListEntity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        let targetSection: TiEntities.SectionTimeSlotEntity = null;
        switch (colName) {
            case "booking":
                value = this.dateToString(entity.booking_date, "dd.MM.yyyy HH:mm");

                value += this.UiModder.domConstruct.create("p", {
                    innerHTML: entity.ref_employee.displayname2 ? entity.ref_employee.displayname2 : "",
                    className: "noMargin"
                }).outerHTML;

                if (entity.tmp_status_webdisplay) {
                    value += this.UiModder.domConstruct.create("p", {
                        innerHTML: entity.tmp_status_webdisplay,
                        className: "bold"
                    }).outerHTML;

                    if (entity.is_contains_canceld_section_timeslot == true) {
                        this.UiModder.domClass.add(cell.tableRow.node, "timeslotWarning");
                    }
                    if (entity.is_cancelled) {
                        this.UiModder.domClass.add(cell.tableRow.node, "cancelled");
                        
                    } 

                }
                
                value += this.UiModder.domConstruct.create("p", {
                    innerHTML: entity.tmp_order_numbers,
                    className: "bold"
                }).outerHTML;


                node.innerHTML = value;
                return true;
                break;
            case "start":
                value += value += this.UiModder.domConstruct.create("p", {
                    innerHTML: entity.tmp_date_start_webdisplay,
                    className: ""
                }).outerHTML;

                node.innerHTML = value;

                return true;
                break;
            case "end":
                value += this.UiModder.domConstruct.create("p", {
                    innerHTML: this.dateToString(entity.target_date, "dd.MM.yyyy HH:mm"),
                    className: ""
                }).outerHTML;

                node.innerHTML = value;
                return true;
                break;

            case "actual_date":
                if (entity.actual_date && entity.target_date) {
                    if (entity.actual_date.valueOf() > entity.target_date.valueOf()) {
                        this.UiModder.domClass.add(node, "warningTXT bold");
                    }
                }

                this.UiModder.domClass.add(node, "noBreak");
                break;
            case "section1":
                targetSection = entity.tmp_section_main_route_timeslot_1;
                break;

            case "section2":
                targetSection = entity.tmp_section_main_route_timeslot_2;
                break;

            case "section3":
                targetSection = entity.tmp_section_main_route_timeslot_3;
                break;

        }


        switch (colName) {
            case "section1":
            case "section2":
            case "section3":
                if (targetSection) {

                    value = this._createSectionCellContent(targetSection);
                    if (targetSection.ref_booking_status_timeslot?.coloration?.BackColor?.Hex) {
                        this.UiModder.domStyle.set(cell.tableCellNode, "backgroundColor", targetSection.ref_booking_status_timeslot.coloration.BackColor.Hex + "44");
                    }
                } else {
                    value = "";
                }
                node.innerHTML = value;
                return true;
        }


        return false;
    }

    private _onClick_Row(row: StaticTable.StaticTableRow<TiEntities.BookingListEntity>, x: any, evt: MouseEvent): void {

        let node = row.node;
        let entity = row.rowGroup.entity;

        this.StandbyStart(node);

        let view = new TiBookingView();

        view.on("change", lang.hitch(this, this._onBookingChanged));
        view.on("loaded", lang.hitch(this, this.StandbyStop));
        view.startup();

        view.setup(entity.ID, {
            showBookingFormConfirmation: false,
            showMainRoute: "noExpander",
            mainRouteViewConfig: {
                sectionsConfig: {
                    enableBookingStatus: "interactive",
                    highlight: false,
                    showExtendedInformation: true
                }
            }
        });


        if (evt) {
            evt.stopPropagation();
        }
    }


    private firstLoadDone: boolean = false;
    private _firstLoad() {
        if (!this.firstLoadDone) {
            this.firstLoadDone = true;
            this.getFilterlist(1);
        }
    }

    private _onBookingChanged(bookingID) {
        this.reload();
    }

    protected _onTableCreated(table: MdsLax<InstanceType<typeof StaticTable>>) {
        //table.addDefaultRowActionButton("view", lang.hitch(this, this._onClick_Row));
       // this.UiModder.domClass.add(table.domNode, "insetColors");
    }

    // --------------------own methods ----------------------------end

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.onDirtyChange = lang.hitch(this, this._firstLoad);

        this.setupFinderWithCallfunctions(
            "Webtool_API_TiRouteSlotsReview__GetFilterpanelOptions",
            "Webtool_API_TiRouteSlotsReview__LoadBookingList",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this._formatTableCell)
        );

        this.on("tableCreated", lang.hitch(this, this._onTableCreated));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles(this.translate("TiRouteSlotsReview__MainTitle"), null);
    }
}

export default mdsWidget(TiRouteSlotReviewList);
